import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import OwnerSettingsComponent from '@components/Owner/Settings';
import { withOwnerLayout } from '@components/Layouts/withOwnerLayout';
import { useOwnerPageGuard } from '@hooks/useOwnerPageGuard';
import { featureFlags } from '@constants/config';

const OwnerSettingsPage = () => {
	const router = useRouter();
	useOwnerPageGuard();

	useEffect(() => {
		if (!featureFlags.SHARE_API_KEYS) {
			router.push('/owner/dashboard');
		}
	}, [router]);

	return (
		<>
			<Head>
				<title>Settings</title>
			</Head>
			<OwnerSettingsComponent />
		</>
	);
};

OwnerSettingsPage.getLayout = withOwnerLayout;

export default OwnerSettingsPage;
